import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Highcharts from 'highcharts/highmaps';
import HighchartsReact from 'highcharts-react-official';
import mapDataWorld from '@highcharts/map-collection/custom/world.geo.json';

const WorldMapChart = () => {
  const { mapGraph } = useSelector((state) => state.data);
  const [options, setOptions] = useState(null);

  // 🔹 Build lookup from mapDataWorld dynamically
  const nameToCode = {};
  mapDataWorld.features.forEach(f => {
    nameToCode[f.properties.name.toLowerCase()] = f.id.toLowerCase();
  });

  useEffect(() => {
    if (!mapGraph || mapGraph.length === 0) return;

    // 🔹 Transform Redux data using dynamic mapping
    const chartData = mapGraph.map(item => {
      const code = nameToCode[item.country.toLowerCase()];
      return [code || item.country.toLowerCase(), item.total_count];
    });

    setOptions({
      chart: {
        map: mapDataWorld,
        backgroundColor: '#fff',
      },
      title: { text: null },
      credits: { enabled: false }, // 🔹 remove "highcharts.com"
      colorAxis: {
        min: 1,
        max: Math.max(...mapGraph.map(d => d.total_count)),
        type: 'logarithmic',
        minColor: '#e6f2ff',
        maxColor: '#0071A4',
      },
      tooltip: {
        pointFormat: '{point.name}: <b>{point.value}</b>'
      },
      series: [
        {
          data: chartData,
          name: 'Visits',
          states: { hover: { color: '#007bffb0', } },

          dataLabels: { enabled: false },
        },
      ],
    });
  }, [mapGraph]);

  return options ? (
    <HighchartsReact
      constructorType={'mapChart'}
      highcharts={Highcharts}
      options={options}
    />
  ) : (
    <p>Loading...</p>
  );
};

export default WorldMapChart;
